import { useEffect, useRef, type EffectCallback, type DependencyList } from "react"

const usePrevious = (value: any, initialValue: any) => {
    const ref = useRef(initialValue)
    useEffect(() => {
        ref.current = value
    })
    return ref.current
}

/**
 * @param effectCallback the useEffect callback.
 * @param dependencies deps array
 * @param dependencyNames (optional) dependency names array for naming properties of the changedDeps prop.
 * @param customHook any custom hook you want to run instead of the default useEffect.
 */
export const useChangeEffect = (
    effectCallback: (changedDeps: any) => any,
    dependencies: any,
    dependencyNames: Array<string> = [],
    customHook: (effect: EffectCallback, deps?: DependencyList) => void,
) => {
    const previousDeps = usePrevious(dependencies, [])

    const changedDeps: any = {}
    for (let i = 0; i < dependencies.length; i++) {
        if (dependencies[i] !== previousDeps[i]) {
            const keyName = dependencyNames[i] || i
            changedDeps[keyName] = { previousValue: previousDeps[i], currentValue: dependencies[i] }
        }
    }
    customHook(() => effectCallback(changedDeps), dependencies)
}
